import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import i18n from './i18n'
import App from './App.vue'
import router from './router'
import { useLanguageStore } from '@/stores/language'
import '@fontsource/spline-sans/300.css'
import '@fontsource/spline-sans/400.css'
import '@fontsource/spline-sans/500.css'
import '@fontsource/spline-sans/600.css'
import '@fontsource/spline-sans/700.css'
import 'material-symbols/outlined.css'

// Vant组件和样式
import { Lazyload, Toast, Dialog, Notify, ImagePreview, showToast, showFailToast } from 'vant'
import 'vant/lib/index.css'
import '@vant/touch-emulator' // 桌面端touch事件支持

// 导入语言包
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

// 创建Vue应用
const app = createApp(App)

// Pinia状态管理
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

// Vue Router
app.use(router)

// 国际化配置（共享实例）
app.use(i18n)

const languageStore = useLanguageStore(pinia)
languageStore.initLanguage()

// Vant组件配置
app.use(Lazyload, {
  lazyComponent: true
})

// 全局配置
app.config.globalProperties.$toast = Toast
app.config.globalProperties.$dialog = Dialog
app.config.globalProperties.$notify = Notify
app.config.globalProperties.$imagePreview = ImagePreview

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err, info)
  showFailToast('系统错误，请稍后重试')
}

// 挂载应用
app.mount('#app')
